import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, FieldArray, formValueSelector } from 'redux-form/immutable';
import { connect } from 'react-redux';

import Input from '../common/Input';
import DatePickerInput from '../common/DatePickerInput';
import SelectBox from '../common/SelectBox';
import ParentsForm from '../parent/ParentsForm';
import CyclesSelect from '../common/CyclesSelect';
import { studentValidation } from '../../utils/validations';
import { categoriesStudents, familyCompositions, howFindUs } from '../../constants/constants';
import { calculateGradeAge, findCycleAndGrade } from '../../utils/helpers';

const StudentForm = ({
  handleSubmit,
  submitting,
  change,
  bids,
  agreements,
  countries,
  category,
  cycles,
  gradeInstances,
  submitText
}) => {
  const onChangeBirthdate = (e, value) => {
    const years = calculateGradeAge(value);
    const { cycleId, gradeId } = findCycleAndGrade(years, cycles);
    if (cycleId && gradeId) {
      const gradeInstanceId = gradeInstances.filter(
        grade => grade.get('gradeId') === gradeId
      ).first().get('id');
      change('cycleId', cycleId);
      change('gradeInstanceId', gradeInstanceId);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="multiple-fields">
        <div>
          <Field
            name="firstName"
            label="Nombre"
            type="text"
            component={Input}
          />
        </div>
        <div>
          <Field
            name="lastName"
            label="Apellido"
            type="text"
            component={Input}
          />
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <Field
            name="ci"
            label="Cédula (sin puntos ni guiones)"
            type="text"
            component={Input}
          />
        </div>
        <div>
          <Field
            name="enrollment"
            label="Matrícula"
            type="text"
            component={Input}
          />
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <Field
            name="admissionDate"
            label="Fecha de inscripción"
            showYearDropdown
            placeholder="DD/MM/AAAA"
            component={DatePickerInput}
          />
        </div>
        <div>
          <Field
            name="birthdate"
            label="Fecha de nacimiento"
            onChange={onChangeBirthdate}
            showYearDropdown
            placeholder="DD/MM/AAAA"
            component={DatePickerInput}
          />
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <Field
            name="nationality"
            label="Nacionalidad"
            options={countries}
            placeholder="Seleccione la nacionalidad"
            component={SelectBox}
          />
        </div>
        <div>
          <Field
            name="inscriptionOffice"
            label="Oficina de inscripción"
            type="text"
            component={Input}
          />
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <Field
            name="address"
            label="Dirección"
            type="text"
            component={Input}
          />
        </div>
        <div>
          <Field
            name="neighborhood"
            label="Barrio"
            type="text"
            component={Input}
          />
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <Field
            name="homePhone"
            label="Teléfono hogar"
            type="text"
            component={Input}
          />
        </div>
        <div>
          <Field
            name="familyComposition"
            label="Composición nucleo familiar"
            options={familyCompositions}
            placeholder="Seleccione una composición"
            component={SelectBox}
          />
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <Field
            name="medicalCare"
            label="Atención Médica"
            type="text"
            component={Input}
          />
        </div>
        <div>
          <Field
            name="medicalEmergency"
            label="Emergencia Médica"
            type="text"
            component={Input}
          />
        </div>
      </div>
      <div className="multiple-fields">
        <div>
          <Field
            name="expirationVaccines"
            label="Fecha de vencimiento vacunas"
            showYearDropdown
            placeholder="DD/MM/AAAA"
            component={DatePickerInput}
          />
        </div>
        <div>
          <Field
            name="expirationPhysicalAptitude"
            label="Fecha de vencimiento de aptitud física"
            showYearDropdown
            placeholder="DD/MM/AAAA"
            component={DatePickerInput}
          />
        </div>
      </div>
      <div>
        <hr />
        <div className="conditional-fields">
          <div>
            <Field
              name="category"
              label="Categoria"
              options={categoriesStudents}
              placeholder="Seleccione una categoria"
              component={SelectBox}
            />
          </div>
          { category === categoriesStudents[2].value &&
            <div>
              <Field
                name="bidId"
                label="Licitación"
                options={bids}
                placeholder="Seleccione la licitación"
                component={SelectBox}
              />
            </div>
          }
          { category === categoriesStudents[1].value &&
            <div>
              <Field
                name="agreementId"
                label="Convenios"
                options={agreements}
                placeholder="Seleccione el convenio"
                component={SelectBox}
              />
            </div>
          }
        </div>
      </div>
      <hr />
      <CyclesSelect />
      <hr />
      <FieldArray
        name="parents"
        component={ParentsForm}
      />
      <hr />
      <div className="other-contact-wrapper">
        <h5>OTRA PERSONA DE CONTACTO</h5>
        <div className="multiple-fields">
          <div>
            <Field
              name="otherContact"
              label="Nombre y apellido"
              type="text"
              component={Input}
            />
          </div>
          <div>
            <Field
              name="otherContactPhone"
              label="Teléfono"
              type="text"
              component={Input}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="single-field">
        <Field
          name="howFindUs"
          label="Como llego a la institución"
          options={howFindUs}
          placeholder="Seleccione una opción"
          component={SelectBox}
        />
      </div>
      <hr />
      <button
        className={`default-button ${submitting ? 'loading-button' : ''}`}
        type="submit"
      >
        { submitText }
      </button>
    </form>
  );
};

const { func, array, bool, string, object } = PropTypes;

StudentForm.propTypes = {
  handleSubmit: func.isRequired,
  submitting: bool.isRequired,
  gradeInstances: object.isRequired,
  bids: array,
  agreements: array,
  countries: array,
  category: string,
  cycles: array,
  change: func,
  submitText: string
};

const selector = formValueSelector('student');

const mapState = state => ({
  category: selector(state, 'category'),
  cycles: state.get('cycle').toJS(),
  gradeInstances: state.getIn(['gradeInstance', 'gradeInstances'])
});

export default connect(mapState)(reduxForm({
  form: 'student',
  validate: studentValidation
})(StudentForm));



// WEBPACK FOOTER //
// ./src/components/student/StudentForm.js